import React, { useEffect, useState } from "react";
import { Button, Col, Container, FormGroup, Label, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import {
  GetQuestionTypeList,
  GetQuestionParentList,
  GetCompetencyCategoryList,
  CreateQuestionData,
} from "../../services/QuestionsService";
import { GetVacancyTypeList } from "../../services/VacancyTypeServices";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { decryptDataFromArray } from "helpers/EncDec";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "react-multi-select-component";

function CreateQuestion() {
  const { t } = useTranslation();
  const [formDataValues, setFormDataValues] = useState({
    option_type: "mcq",
    total_options: 4,
    is_critical: "0",
  });
  const [errors, setErrors] = useState("");
  const status = [
    { label: "Active", value: "1", id: "1" },
    { label: "Inactive", value: "0", id: "0" },
  ];

  const history = useHistory();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [selectedAudioFile, setSelectedAudioFile] = useState(null);
  const [vacancyType, setVacancyType] = useState([]);
  const [competencyCategory, setCompetencyCategory] = useState([]);
  const [questionType, setQuestionType] = useState({});
  const [questionParent, setQuestionParent] = useState({});
  const [isValidParent, setIsValidParent] = useState(true);
  const [isValidTextPreced, setIsValidTextPreced] = useState(true);
  const lang_id =
    localStorage.getItem("lang_id") && localStorage.getItem("lang_id") !== "1"
      ? localStorage.getItem("lang_id")
      : "1";

  const optionValues = [
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
  ];

  const optionTypeValues = [
    { value: "text", label: "Text-Based" },
    { value: "mcq", label: "Multiple Choice (MCQ)" },
  ];

  const question_categories = [
    {
      label: "Default",
      value: 0,
      id: 0,
    },
    {
      label: "Basic",
      value: 1,
      id: 1,
    },
    {
      label: "Intermediate",
      value: 2,
      id: 2,
    },
    {
      label: "Expert",
      value: 3,
      id: 3,
    },
    {
      label: "Situational Judgement",
      value: 4,
      id: 4,
    },
  ];
  const [questionCategory, setQuestionCategory] = useState(0);
  const [weightageValue, setWeightageValue] = useState([]);

  useEffect(() => {
    switch (questionCategory) {
      case 0:
        setWeightageValue([
          { label: "0", value: "0", id: "0" },
          { label: "1", value: "1", id: "1" },
          { label: "2", value: "2", id: "2" },
        ]);
        break;
      case 1:
        setWeightageValue([
          { label: "0", value: "0", id: "0" },
          { label: "1", value: "1", id: "1" },
        ]);
        break;
      case 2:
        setWeightageValue([
          { label: "0", value: "0", id: "0" },
          { label: "2", value: "2", id: "1" },
        ]);
        break;
      case 3:
        setWeightageValue([
          { label: "0", value: "0", id: "0" },
          { label: "3", value: "3", id: "1" },
        ]);
        break;
      case 4:
        setWeightageValue([
          { label: "0", value: "0", id: "0" },
          { label: "4", value: "4", id: "1" },
        ]);
        break;
    }
  }, [questionCategory]);
  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  useEffect(() => {
    const lang_id =
      localStorage.getItem("lang_id") !== "1"
        ? localStorage.getItem("lang_id")
        : "1";
    GetVacancyTypeList(lang_id)
      .then(res => {
        let responseData = decryptDataFromArray(res?.data);
        if (responseData?.status) {
          let vacrr = responseData?.data?.map(item => ({
            label: item?.title,
            value: item?.id,
            id: item?.id,
          }));
          setVacancyType(vacrr);
        } else {
          setErrors("No data available");
        }
      })
      .catch(err => {
        setErrors("No data Available");
      });
  }, []);

  useEffect(() => {
    const lang_id =
      localStorage.getItem("lang_id") !== "1"
        ? localStorage.getItem("lang_id")
        : "1";
    GetQuestionTypeList(lang_id)
      .then(res => {
        if (res?.data?.status) {
          let qt = res?.data?.data?.map(items => ({
            label: items?.ques_type,
            value: items?.id,
            id: items?.id,
            slug: items?.slug,
          }));
          setQuestionType(qt);
        }
      })
      .catch(err => {
        console.error("Error fetching department list:", err);
      });
  }, []);
  const extendedOptions = [...competencyCategory];

  useEffect(() => {
    GetQuestionParentList()
      .then(res => {
        if (res?.status === 200 && res.data.data.length !== 0) {
          let qp = res?.data?.data?.map(item => ({
            label: item?.ques_parent,
            value: item?.id,
            id: item?.id,
          }));
          setQuestionParent(qp);
        } else {
          setQuestionParent([]);
        }
      })
      .catch(err => {
        setErrors("No data Available");
      });
  }, []);

  const handleChangeVacancyTypeValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      vacancy_type_id: e?.value,
    }));

    handleComptCategoryPopulate(e?.value);
  };

  const handleChangeQuestionTypeValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      ques_type_id: e?.value,
    }));
  };

  const handleChangeQuestionParentValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      ques_parent_id: e?.value,
    }));

    if (e?.value) {
      setIsValidParent(true);
      setIsValidTextPreced(false); // Set this to false to hide the Text Preceding item field
    } else {
      setIsValidParent(false);
      setIsValidTextPreced(true); // Set this to true to show the Text Preceding item field
    }
  };
  const handleChanges = selectedOptions => {
    setSelectedOptions(selectedOptions);
    const allcompcategory = selectedOptions?.map(
      competencyCategory => competencyCategory.id
    );
    setFormDataValues(prevState => ({
      ...prevState,
      compt_id: allcompcategory, // Update Job_id in statePayload with all Job values
    }));
  };
  const handleComptCategoryPopulate = async type_id => {
    if (type_id) {
      const lang_id =
        localStorage.getItem("lang_id") !== "1"
          ? localStorage.getItem("lang_id")
          : "1";
      await GetCompetencyCategoryList(type_id, lang_id)
        .then(res => {
          let responseData = res?.data;
          // responseData = decryptDataFromArray(responseData);

          if (responseData?.status) {
            let competencyCategories = responseData?.data?.map(item => ({
              label: item?.name,
              value: item?.id,
              id: item?.id,
            }));

            setCompetencyCategory(competencyCategories);
          }
        })
        .catch(err => {
          setErrors("No data Available");
        });
    }
  };

  const handleBehavioursChangeValuePopulate = (value, key) => {
    let behvArr = value?.map(item => item?.id);
    setFormDataValues(prevState => ({
      ...prevState,
      [key]: behvArr,
    }));
  };

  const handleImageFileChange = e => {
    const file = e?.target?.files?.[0];

    // Check if file size is less than 2 MB
    if (file.size > 2 * 1024 * 1024) {
      // File size exceeds 2 MB, show error message or take appropriate action
      alert("File size must be less than 2 MB");
      return; // Stop further execution
    }

    // Proceed with handling the file if it passes the size validation
    const reader = new FileReader();
    reader.onload = () => {
      // setFormDataValues(reader.result);
    };
    reader.readAsArrayBuffer(file);
    if (file) {
      setSelectedImageFile(file);
    }
  };

  const handleChangeStatusValue = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      status: e?.id,
    }));
  };

  const handleAudioFileChange = e => {
    const file = e?.target?.files?.[0];
    const reader = new FileReader();

    reader.readAsArrayBuffer(file);
    // Set the selected audio file in the component state
    if (file) {
      setSelectedAudioFile(file);
    }
  };

  const handleChangeWeightage1 = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      weightage1: e?.value,
    }));
  };
  const handleChangeWeightage2 = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      weightage2: e?.value,
    }));
  };
  const handleChangeWeightage3 = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      weightage3: e?.value,
    }));
  };
  const handleChangeWeightage4 = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      weightage4: e?.value,
    }));
  };
  /* Handle Change Event */
  const handleChange = e => {
    const { name, value } = e.target;
    setFormDataValues({
      ...formDataValues,
      [name]: value,
    });

    if (value) {
      setIsValidParent(false);
      setIsValidTextPreced(true);
    } else {
      setIsValidParent(true);
      setIsValidTextPreced(false);
    }
  };
  // Validation logic for each field
  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    if (!formDataValues.vacancy_type_id) {
      newErrors.vacancy_type_id = t(`mcq_manager.PleaseSelectVacancyType`);
      isValid = false;
    }
    if (!formDataValues.compt_id?.length) {
      newErrors.compt_id = t(`mcq_manager.PleaseSelectCompetencyCategory`);
      isValid = false;
    }

    if (!formDataValues.question) {
      newErrors.question = t(`mcq_manager.QuestionFieldRequired`);
      isValid = false;
    }
    if (!formDataValues.option1) {
      newErrors.option1 = t(`mcq_manager.Option1FieldRequired`);
      isValid = false;
    }
    if (!formDataValues.option2 && formDataValues?.option_type === "mcq") {
      newErrors.option2 = t(`mcq_manager.Option2FieldRequired`);
      isValid = false;
    }
    if (
      !formDataValues.option3 &&
      formDataValues?.option_type === "mcq" &&
      formDataValues?.total_options > 2
    ) {
      newErrors.option3 = t(`mcq_manager.Option3FieldRequired`);
      isValid = false;
    }
    if (
      !formDataValues.option4 &&
      formDataValues?.option_type === "mcq" &&
      formDataValues?.total_options > 3
    ) {
      newErrors.option4 = t(`mcq_manager.Option4FieldRequired`);
      isValid = false;
    }
    if (!formDataValues.weightage1) {
      newErrors.weightage2 = t(`mcq_manager.Weightage1FieldRequired`);
      isValid = false;
    }
    if (!formDataValues.weightage2 && formDataValues?.option_type === "mcq") {
      newErrors.weightage2 = t(`mcq_manager.Weightage2FieldRequired`);
      isValid = false;
    }
    if (
      !formDataValues.weightage3 &&
      formDataValues?.option_type === "mcq" &&
      formDataValues?.total_options > 2
    ) {
      newErrors.weightage3 = t(`mcq_manager.Weightage2FieldRequired`);
      isValid = false;
    }
    if (
      !formDataValues.weightage4 &&
      formDataValues?.option_type === "mcq" &&
      formDataValues?.total_options > 3
    ) {
      newErrors.weightage4 = t(`mcq_manager.Weightage3FieldRequired`);
      isValid = false;
    }
    if (!formDataValues.status) {
      newErrors.status = t(`mcq_manager.PleaseSelectStatusOption`);
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async e => {
    if (validateForm()) {
      let formData = new FormData();

      // Append fields with their values to formData
      formData.append("question", e?.question);
      formData.append("vacancy_type_id", e?.vacancy_type_id);
      formData.append("ques_type_id", e?.ques_type_id);
      formData.append("compt_id", e?.compt_id);
      formData.append("ques_category_id", questionCategory);
      formData.append("ques_parent_id", e?.ques_parent_id || 0);
      formData.append("ques_behav_id", JSON.stringify(e?.ques_behav_id) || 0);
      formData.append("enabler", e?.enabler || null);
      formData.append("scenario", e?.scenario || 0);
      formData.append("text_preced_item", e?.text_preced_item || null);
      formData.append("option1", e?.option1 || "");
      formData.append(
        "option2",
        formDataValues?.option_type === "text" ? "" : e?.option2 || ""
      );
      formData.append(
        "option3",
        formDataValues?.option_type === "text" ? "" : e?.option3 || ""
      );
      formData.append(
        "option4",
        formDataValues?.option_type === "text" ? "" : e?.option4 || ""
      );
      formData.append("weightage1", e?.weightage1 || 0);
      formData.append(
        "weightage2",
        formDataValues?.option_type === "text" ? 0 : e?.weightage2 || 0
      );
      formData.append(
        "weightage3",
        formDataValues?.option_type === "text" ? 0 : e?.weightage3 || 0
      );
      formData.append(
        "weightage4",
        formDataValues?.option_type === "text" ? 0 : e?.weightage4 || 0
      );
      formData.append("answer", e?.answer || null);
      formData.append("status", e?.status);
      formData.append("option_type", formDataValues?.option_type);
      formData.append(
        "total_options",
        formDataValues?.option_type === "text"
          ? 1
          : formDataValues?.total_options
      );
      formData.append("is_critical", formDataValues?.is_critical);

      // Append file fields if they are selected
      if (selectedImageFile) {
        formData.append("image_file", selectedImageFile);
      }
      if (selectedAudioFile) {
        formData.append("audio_file", selectedAudioFile);
      }

      await CreateQuestionData(formData, lang_id)
        .then(res => {
          if (res?.status === 200) {
            let messages = toast.success(res?.data?.message);
            history.push("/questions-list");
          } else {
            let messages = toast.error(res?.data?.message);
          }
        })
        .catch(err => {
          console.error("Error fetching list:", err);
          setErrors("No data created.");
        });
    } else {
      console.error("Form has errors");
    }
  };

  if (!checkPermissionStatus("questions-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="joblist-container create-vacancy">
        <Row className="mb-3 align-items-center py-2 pt-0">
          <Col lg="6" md="6">
            <Link to="/questions-list">
              <h5 className="text-uppercase heading-one">
                <img src={arrow_btn} alt="arrow_btn" />
                {t(`mcq_manager.Add Question`)}
              </h5>
            </Link>
          </Col>
          {/* <Col lg="6" md="6">
              <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                <Link to="/questions-list" className="btn btn-primary">
                  Back To Listing
                </Link>
              </div>
            </Col> */}
        </Row>
      </div>

      <div className="outerTab-box-wrapper below-vacancy">
        <div className="form-details-section mt-3">
          <Container fluid>
            {/* <Breadcrumbs title="Question" breadcrumbItem="Add Question" /> */}

            <AvForm
              className="outer-repeater col-12"
              key={formDataValues?.option_type} // This forces remount of form on type change
              onValidSubmit={() => {
                handleSubmit(formDataValues);
              }}
            >
              <div data-repeater-list="outer-group" className="outer">
                <div data-repeater-item className="outer">
                  <Row>
                    <Col lg="12">
                      <FormGroup className="mb-2" row>
                        <Label htmlFor="question" className="col-form-label">
                          {t(`mcq_manager.Add Question`)}
                          <span className="text-danger">*</span>
                        </Label>
                        <div title={t(`mcq_manager.Add Question`)}>
                          <AvField
                            type="textarea"
                            className="form-control"
                            id="question"
                            name="question"
                            placeholder={t(`mcq_manager.Question`)}
                            errorMessage="Question item Required."
                            style={{ height: "100px" }}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t(
                                  `mcq_manager.QuestionItemRequired`
                                ),
                              },
                              minLength: {
                                value: 1,
                                errorMessage:
                                  "Question item must be at least 1 characters",
                              },
                            }}
                            value={formDataValues?.question || ""}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="error">{errors.question}</div>
                      </FormGroup>
                    </Col>

                    <Col lg="4">
                      <FormGroup className="mb-2" row>
                        <Label
                          htmlFor="vacancy_type_id"
                          className="col-form-label"
                        >
                          {t(`mcq_manager.Vacancy Type`)}
                          <span className="text-danger">*</span>
                        </Label>

                        <div
                          title={
                            formDataValues.vacancy_type_id
                              ? `${
                                  vacancyType.find(
                                    elem =>
                                      elem.value ==
                                      formDataValues.vacancy_type_id
                                  )?.label
                                }`
                              : `${t("mcq_manager.Vacancy Type")}`
                          }
                        >
                          <Select
                            className="mb-2"
                            placeholder="Select Type"
                            id="vacancy_type_id"
                            name="vacancy_type_id"
                            validate={{ required: { value: true } }}
                            options={vacancyType}
                            onChange={e =>
                              handleChangeVacancyTypeValuePopulate(e)
                            }
                            aria-label={t(`mcq_manager.Status`)} // Adds an ARIA label
                            tabIndex="0" // Explicitly specifies focusable tabindex
                          />
                        </div>
                        <div className="error">{errors.vacancy_type_id}</div>
                      </FormGroup>
                    </Col>

                    <Col lg="4">
                      <FormGroup className="mb-2" row>
                        <Label
                          htmlFor="competency_category"
                          className="col-form-label"
                        >
                          {t(`mcq_manager.Competency Category`)}
                          <span className="text-danger">*</span>
                        </Label>
                        <div className="selectoption">
                          <MultiSelect
                            options={extendedOptions}
                            value={selectedOptions}
                            onChange={handleChanges}
                            overrideStrings={{
                              selectSomeItems: `Select Competency Category`,
                            }}
                          />
                        </div>
                        {errors?.compt_id && (
                          <div className="error">{errors?.compt_id}</div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col lg="4">
                      <FormGroup className="mb-2" row>
                        <Label
                          htmlFor="ques_type_id"
                          className="col-form-label"
                        >
                          {t(`mcq_manager.Question Type`)}
                          <span className="text-danger">*</span>
                        </Label>

                        <div
                          title={
                            formDataValues.ques_type_id
                              ? `${
                                  questionType.find(
                                    elem =>
                                      elem.value == formDataValues.ques_type_id
                                  )?.label
                                }`
                              : `${t("mcq_manager.Question Type")}`
                          }
                        >
                          <Select
                            className="mb-2"
                            placeholder={t(`mcq_manager.Select Question Type`)}
                            id="ques_type_id"
                            name="ques_type_id"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Question Type item is required",
                              },
                            }}
                            options={
                              Array.isArray(questionType) ? questionType : []
                            }
                            onChange={e =>
                              handleChangeQuestionTypeValuePopulate(e)
                            }
                            aria-label={t(`mcq_manager.Question Type`)} // Adds an ARIA label
                            tabIndex="0" // Explicitly specifies focusable tabindex
                          />
                        </div>
                        <div className="error">{errors.ques_type_id}</div>
                      </FormGroup>
                    </Col>

                    <Col lg="4">
                      <FormGroup className="mb-2" row>
                        <Label
                          htmlFor="ques_type_id"
                          className="col-form-label"
                        >
                          {t(`mcq_manager.Option Type`)}
                          <span className="text-danger">*</span>
                        </Label>

                        <div
                          title={
                            formDataValues.option_type
                              ? `${
                                  optionTypeValues.find(
                                    elem =>
                                      elem.value == formDataValues.option_type
                                  )?.label
                                }`
                              : `${t("mcq_manager.Question Type")}`
                          }
                        >
                          <Select
                            className="mb-2"
                            placeholder="Select Option Type"
                            id="option_type"
                            name="option_type"
                            validate={{
                              required: {
                                value: true,
                                errorMessage: "Option Type item is required",
                              },
                            }}
                            options={
                              Array.isArray(optionTypeValues)
                                ? optionTypeValues
                                : []
                            }
                            value={optionTypeValues?.find(
                              el => el?.value === formDataValues?.option_type
                            )}
                            onChange={e =>
                              setFormDataValues(prevState => ({
                                ...prevState,
                                option_type: e?.value,
                              }))
                            }
                            aria-label={t(`mcq_manager.Option Type`)} // Adds an ARIA label
                            tabIndex="0" // Explicitly specifies focusable tabindex
                          />
                        </div>
                        <div className="error">{errors.option_type}</div>
                      </FormGroup>
                    </Col>

                    {formDataValues?.option_type === "mcq" ? (
                      <>
                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="questionCategory"
                              className="col-form-label"
                            >
                              {`Question Category`}
                              <span className="text-danger">*</span>
                            </Label>

                            <div
                              title={
                                formDataValues.questionCategory
                                  ? `${
                                      questionCategory.find(
                                        elem =>
                                          elem.value ==
                                          formDataValues.questionCategory
                                      )?.label
                                    }`
                                  : `${t("Question Category")}`
                              }
                            >
                              <Select
                                className="mb-2"
                                placeholder="Select Question Category"
                                id="questionCategory"
                                name="questionCategory"
                                value={question_categories.find(
                                  e => e.value === questionCategory
                                )}
                                options={question_categories}
                                onChange={e => {
                                  setQuestionCategory(e.value);
                                  setFormDataValues(prevState => ({
                                    ...prevState,
                                    weightage1: "",
                                    weightage2: "",
                                    weightage3: "",
                                    weightage4: "",
                                  }));
                                }}
                                aria-label={t(`Question Category`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ques_type_id"
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Total Options`)}
                              <span className="text-danger">*</span>
                            </Label>

                            <div
                              title={
                                formDataValues.total_options
                                  ? `${
                                      optionValues.find(
                                        elem =>
                                          elem.value ==
                                          formDataValues.total_options
                                      )?.label
                                    }`
                                  : `${t("Question Category")}`
                              }
                            >
                              <Select
                                className="mb-2"
                                placeholder={t(`mcq_manager.Select Options`)}
                                id="total_options"
                                name="total_options"
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage:
                                      "Total Options item is required",
                                  },
                                }}
                                options={
                                  Array.isArray(optionValues)
                                    ? optionValues
                                    : []
                                }
                                value={optionValues?.find(
                                  el =>
                                    el?.value === formDataValues?.total_options
                                )}
                                onChange={e =>
                                  setFormDataValues(prevState => ({
                                    ...prevState,
                                    total_options: e?.value,
                                  }))
                                }
                                aria-label={t(`mcq_manager.Select Options`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                            <div className="error">{errors.total_options}</div>
                          </FormGroup>
                        </Col>
                      </>
                    ) : (
                      <Col lg={6}></Col>
                    )}

                    {formDataValues.ques_type_id === 1 && isValidParent && (
                      <Col lg="4">
                        <FormGroup className="mb-2" row>
                          <Label
                            htmlFor="ques_parent_id"
                            className="col-form-label"
                          >
                            {t(`mcq_manager.Question Parent`)}
                            <span className="text-danger">*</span>
                          </Label>
                          <div
                            title={
                              formDataValues.ques_parent_id
                                ? `${
                                    questionParent.find(
                                      elem =>
                                        elem.value ==
                                        formDataValues.ques_parent_id
                                    )?.label
                                  }`
                                : `${t("mcq_manager.Question Parent")}`
                            }
                          >
                            <Select
                              className="mb-2"
                              placeholder={t(
                                `mcq_manager.Select Question Parent`
                              )}
                              id="ques_parent_id"
                              name="ques_parent_id"
                              options={
                                Array.isArray(questionParent)
                                  ? questionParent
                                  : []
                              }
                              onChange={e =>
                                handleChangeQuestionParentValuePopulate(e)
                              }
                              aria-label={t(`mcq_manager.Question Parent`)} // Adds an ARIA label
                              tabIndex="0" // Explicitly specifies focusable tabindex
                            />
                          </div>
                          <div className="error">{errors.ques_parent_id}</div>
                        </FormGroup>
                      </Col>
                    )}

                    {formDataValues.ques_type_id === 1 && isValidTextPreced && (
                      <>
                        <Col lg="12">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="text_preced_item"
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Text Preceding item`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <div title={t(`mcq_manager.Text Preceding item`)}>
                              <AvField
                                type="text"
                                className="form-control"
                                id="text_preced_item"
                                name="text_preced_item"
                                placeholder={t(
                                  `mcq_manager.Text Preceding item`
                                )}
                                errorMessage="Text Preceding item Required."
                                style={{ height: "100px" }}
                                value={formDataValues?.text_preced_item || ""}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="error">
                              {errors.text_preced_item}
                            </div>
                          </FormGroup>
                        </Col>
                      </>
                    )}

                    {formDataValues?.option_type === "text" && (
                      <>
                        <Col lg="8">
                          <FormGroup className="mb-2" row>
                            <Label htmlFor="option1" className="col-form-label">
                              {t(`mcq_manager.Answer`)}{" "}
                              <span className="text-danger">*</span>
                            </Label>

                            <div title={t(`mcq_manager.Answer`)}>
                              <AvField
                                type="textarea"
                                className="form-control"
                                id="option1"
                                name="option1"
                                placeholder={t(`mcq_manager.Enter Answer`)}
                                errorMessage="Answer is Required."
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Answer is required",
                                  },
                                  minLength: {
                                    value: 1,
                                    errorMessage:
                                      "Answer must be at least 1 characters",
                                  },
                                }}
                                value={formDataValues?.option1 || ""}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="error">{errors.option1}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="4">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="weightage1"
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Weightage`)} %
                              <span className="text-danger">*</span>
                            </Label>

                            <div title={t(`mcq_manager.Weightage`)}>
                              <AvField
                                type="number"
                                className="form-control"
                                id="weightage1"
                                name="weightage1"
                                placeholder="Enter Weightage %"
                                errorMessage="Weightage is Required."
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Weightage is required",
                                  },
                                }}
                                onChange={e => {
                                  setFormDataValues(prevState => ({
                                    ...prevState,
                                    weightage1: e?.target?.value,
                                  }));
                                }}
                                onBlur={e => {
                                  if (e.target.value < 1) {
                                    setFormDataValues(prevState => ({
                                      ...prevState,
                                      weightage1: 1,
                                    }));
                                  }
                                  if (e.target.value > 101) {
                                    setFormDataValues(prevState => ({
                                      ...prevState,
                                      weightage1: 100,
                                    }));
                                  }
                                }}
                                aria-label={t(`mcq_manager.Weightage`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                            <div className="error">{errors.weightage1}</div>
                          </FormGroup>
                        </Col>
                      </>
                    )}

                    {formDataValues?.option_type === "mcq" && (
                      <>
                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label htmlFor="option1" className="col-form-label">
                              {t(`mcq_manager.Option 1`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <div title={t(`mcq_manager.Option 1`)}>
                              <AvField
                                type="text"
                                className="form-control"
                                id="option1"
                                name="option1"
                                placeholder="Option 1 item"
                                errorMessage="Option 1 item Required."
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: t(
                                      `mcq_manager.Option1ItemRequired`
                                    ),
                                  },
                                  minLength: {
                                    value: 1,
                                    errorMessage:
                                      "Option 1 item must be at least 1 characters",
                                  },
                                }}
                                value={formDataValues?.option1 || ""}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="error">{errors.option1}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="weightage1"
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Weightage 1`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <div
                              title={
                                formDataValues.weightage1
                                  ? `${
                                      weightageValue.find(
                                        elem =>
                                          elem.value ==
                                          formDataValues.weightage1
                                      )?.label
                                    }`
                                  : `${t("mcq_manager.Weightage 1")}`
                              }
                            >
                              <Select
                                className="mb-2"
                                placeholder="Select weightage 1 value."
                                id="weightage1"
                                name="weightage1"
                                errorMessage="Weightage 1 item Required."
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage:
                                      "Weightage 1 item is required",
                                  },
                                  minLength: {
                                    value: 1,
                                    errorMessage:
                                      "Weightage 1 item must be at least 1 characters",
                                  },
                                }}
                                options={
                                  Array.isArray(weightageValue)
                                    ? weightageValue
                                    : []
                                }
                                value={
                                  weightageValue.find(
                                    e => e.value === formDataValues?.weightage1
                                  ) || null
                                }
                                onChange={e => handleChangeWeightage1(e)}
                                aria-label={t(`mcq_manager.Weightage 1`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>
                            <div className="error">{errors.weightage1}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label htmlFor="option2" className="col-form-label">
                              {t(`mcq_manager.Option 2`)}
                              <span className="text-danger">*</span>
                            </Label>

                            <div title={t(`mcq_manager.Option 2`)}>
                              <AvField
                                type="text"
                                className="form-control"
                                id="option2"
                                name="option2"
                                placeholder="Option 2 item"
                                errorMessage="Option 2 item Required."
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: t(
                                      `mcq_manager.Option2ItemRequired`
                                    ),
                                  },
                                  minLength: {
                                    value: 1,
                                    errorMessage:
                                      "Option 2 item must be at least 1 characters",
                                  },
                                }}
                                value={formDataValues?.option2 || ""}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="error">{errors.option2}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="weightage2"
                              className="col-form-label"
                            >
                              {t(`mcq_manager.Weightage 2`)}
                              <span className="text-danger">*</span>
                            </Label>
                            <div
                              title={
                                formDataValues.weightage2
                                  ? `${
                                      weightageValue.find(
                                        elem =>
                                          elem.value ==
                                          formDataValues.weightage2
                                      )?.label
                                    }`
                                  : `${t("mcq_manager.Weightage 2")}`
                              }
                            >
                              <Select
                                className="mb-2"
                                placeholder="Select weightage 2 value"
                                id="weightage2"
                                name="weightage2"
                                errorMessage="Weightage 2 item Required."
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage:
                                      "Weightage 2 item is required",
                                  },
                                  minLength: {
                                    value: 1,
                                    errorMessage:
                                      "Weightage 2 item must be at least 1 characters",
                                  },
                                }}
                                options={
                                  Array.isArray(weightageValue)
                                    ? weightageValue
                                    : []
                                }
                                value={
                                  weightageValue.find(
                                    e => e.value === formDataValues?.weightage2
                                  ) || null
                                }
                                onChange={e => handleChangeWeightage2(e)}
                                aria-label={t(`mcq_manager.Weightage 2`)} // Adds an ARIA label
                                tabIndex="0" // Explicitly specifies focusable tabindex
                              />
                            </div>

                            <div className="error">{errors.weightage2}</div>
                          </FormGroup>
                        </Col>

                        {formDataValues?.total_options > 2 && (
                          <>
                            <Col lg="6">
                              <FormGroup className="mb-2" row>
                                <Label
                                  htmlFor="option3"
                                  className="col-form-label"
                                >
                                  {t(`mcq_manager.Option 3`)}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div title={t(`mcq_manager.Option 3`)}>
                                  <AvField
                                    type="text"
                                    className="form-control"
                                    id="option3"
                                    name="option3"
                                    placeholder="Option 3 item"
                                    errorMessage="Option 3 item Required."
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: t(
                                          `mcq_manager.Option3ItemRequired`
                                        ),
                                      },
                                      minLength: {
                                        value: 1,
                                        errorMessage:
                                          "Option 3 item must be at least 1 characters",
                                      },
                                    }}
                                    value={formDataValues?.option3 || ""}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div className="error">{errors.option3}</div>
                              </FormGroup>
                            </Col>

                            <Col lg="6">
                              <FormGroup className="mb-2" row>
                                <Label
                                  htmlFor="weightage3"
                                  className="col-form-label"
                                >
                                  {t(`mcq_manager.Weightage 3`)}
                                  <span className="text-danger">*</span>
                                </Label>
                                <div
                                  title={
                                    formDataValues.weightage3
                                      ? `${
                                          weightageValue.find(
                                            elem =>
                                              elem.value ==
                                              formDataValues.weightage3
                                          )?.label
                                        }`
                                      : `${t("mcq_manager.Weightage 2")}`
                                  }
                                >
                                  <Select
                                    className="mb-2"
                                    placeholder="Select weightage 3 value."
                                    id="weightage3"
                                    name="weightage3"
                                    errorMessage="Weightage 3 item Required."
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage:
                                          "Weightage 3 item is required",
                                      },
                                      minLength: {
                                        value: 1,
                                        errorMessage:
                                          "Weightage 3 item must be at least 1 characters",
                                      },
                                    }}
                                    options={
                                      Array.isArray(weightageValue)
                                        ? weightageValue
                                        : []
                                    }
                                    value={
                                      weightageValue.find(
                                        e =>
                                          e.value === formDataValues?.weightage3
                                      ) || null
                                    }
                                    onChange={e => handleChangeWeightage3(e)}
                                    aria-label={t(`mcq_manager.Weightage 3`)} // Adds an ARIA label
                                    tabIndex="0" // Explicitly specifies focusable tabindex
                                  />
                                </div>
                                <div className="error">{errors.weightage3}</div>
                              </FormGroup>
                            </Col>
                          </>
                        )}

                        {formDataValues?.total_options > 3 && (
                          <>
                            <Col lg="6">
                              <FormGroup className="mb-2" row>
                                <Label
                                  htmlFor="option4"
                                  className="col-form-label"
                                >
                                  {t(`mcq_manager.Option 4`)}
                                  <span className="text-danger">*</span>
                                </Label>

                                <div title={t(`mcq_manager.Option 4`)}>
                                  <AvField
                                    type="text"
                                    className="form-control"
                                    id="option4"
                                    name="option4"
                                    placeholder="Option 4 item"
                                    errorMessage="Option 4 item Required."
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage: t(
                                          `mcq_manager.Option4ItemRequired`
                                        ),
                                      },
                                      minLength: {
                                        value: 1,
                                        errorMessage:
                                          "Option 4 item must be at least 1 characters",
                                      },
                                    }}
                                    value={formDataValues?.option4 || ""}
                                    onChange={handleChange}
                                  />
                                </div>
                                <div className="error">{errors.option4}</div>
                              </FormGroup>
                            </Col>

                            <Col lg="6">
                              <FormGroup className="mb-2" row>
                                <Label
                                  htmlFor="weightage4"
                                  className="col-form-label"
                                >
                                  {t(`mcq_manager.Weightage 4`)}
                                  <span className="text-danger">*</span>
                                </Label>

                                <div
                                  title={
                                    formDataValues.weightage4
                                      ? `${
                                          weightageValue.find(
                                            elem =>
                                              elem.value ==
                                              formDataValues.weightage4
                                          )?.label
                                        }`
                                      : `${t("mcq_manager.Weightage 2")}`
                                  }
                                >
                                  <Select
                                    className="mb-2"
                                    placeholder="Select weightage 4 value."
                                    id="weightage4"
                                    name="weightage4"
                                    errorMessage="Weightage 4 item Required."
                                    validate={{
                                      required: {
                                        value: true,
                                        errorMessage:
                                          "Weightage 4 item is required",
                                      },
                                      minLength: {
                                        value: 1,
                                        errorMessage:
                                          "Weightage 4 item must be at least 1 characters",
                                      },
                                    }}
                                    options={
                                      Array.isArray(weightageValue)
                                        ? weightageValue
                                        : []
                                    }
                                    value={
                                      weightageValue.find(
                                        e =>
                                          e.value === formDataValues?.weightage4
                                      ) || null
                                    }
                                    onChange={e => handleChangeWeightage4(e)}
                                    aria-label={t(`mcq_manager.Weightage 4`)} // Adds an ARIA label
                                    tabIndex="0" // Explicitly specifies focusable tabindex
                                  />
                                </div>
                                <div className="error">{errors.weightage4}</div>
                              </FormGroup>
                            </Col>
                          </>
                        )}
                      </>
                    )}
                    {/* <Col lg="6">
                        <FormGroup className="mb-2" row>
                          <Label htmlFor="answer" className="col-form-label">
                            Question Answer
                            <span className="text-danger">*</span>
                          </Label>

                          <Select
                            className="mb-2"
                            placeholder="Select Answer"
                            id="answer"
                            name="answer"
                            options={questionAnswer}
                            onChange={e => handleChangeAnswerValue(e)}
                          />
                          <div className="error">{errors.answer}</div>
                        </FormGroup>
                      </Col> */}

                    <Col lg="4">
                      <FormGroup className="mb-2" row>
                        <Label htmlFor="image_file" className="col-form-label">
                          {t(`mcq_manager.Question Image`)}
                          <span className="text-danger">
                            {" "}
                            ({t(`mcq_manager.File size must be less than 2 MB`)}
                            )
                          </span>
                        </Label>
                        <div title={t(`mcq_manager.Question Image`)}>
                          <AvField
                            type="file"
                            className="form-control"
                            id="image_file"
                            name="image_file"
                            accept=".jpeg, .png, .jpg, .gif"
                            errorMessage="The file is required."
                            onChange={handleImageFileChange}
                          />
                        </div>
                        <div className="error">{errors.image_file}</div>
                      </FormGroup>
                    </Col>

                    <Col lg="4">
                      <FormGroup className="mb-2" row>
                        <Label htmlFor="audio_file" className="col-form-label">
                          {t(`mcq_manager.Question Audio`)}
                        </Label>
                        <div title={t(`mcq_manager.Question Audio`)}>
                          <AvField
                            type="file"
                            className="form-control"
                            id="audio_file"
                            name="audio_file"
                            errorMessage="The file is required."
                            accept="audio/*, video/*"
                            onChange={handleAudioFileChange}
                          />
                        </div>
                        <div className="error">{errors.audio_file}</div>
                      </FormGroup>
                      <span className="text-danger">
                        {" "}
                        (
                        {t(
                          `mcq_manager.File length/duration must be less than 1 minute`
                        )}
                        )
                      </span>
                    </Col>

                    <Col lg="4">
                      <FormGroup className="mb-4" row>
                        <Label className="col-form-label">
                          {t(`mcq_manager.Status`)}:
                          <span className="text-danger">*</span>{" "}
                        </Label>

                        <div
                          title={
                            formDataValues.status
                              ? `${
                                  status.find(
                                    elem => elem.value == formDataValues.status
                                  )?.label
                                }`
                              : `${t("mcq_manager.Status")}`
                          }
                        >
                          <Select
                            className="mb-2"
                            placeholder="Select Status"
                            id="status_id"
                            name="status"
                            validate={{ required: { value: true } }}
                            options={status}
                            onChange={e => handleChangeStatusValue(e)}
                            aria-label={t(`mcq_manager.Status`)} // Adds an ARIA label
                            tabIndex="0" // Explicitly specifies focusable tabindex
                          />
                        </div>
                        <div className="error">{errors.status}</div>
                      </FormGroup>
                    </Col>

                    <Col lg="4">
                      <FormGroup className="mb-4" row>
                        <Label className="col-form-label">
                          {t(`mcq_manager.Critical Question`)}:
                          <span className="text-danger">*</span>{" "}
                        </Label>

                        <div className="mt-2">
                          <label className="switch" htmlFor="is_critical">
                            <span className="visually-hidden">
                              {t(`mcq_manager.Is Critical`)}{" "}
                            </span>
                            {/* Add the content for the label */}
                            <input
                              type="checkbox"
                              id="is_critical"
                              onClick={e => {
                                let value = e.target.checked ? "1" : "0";
                                setFormDataValues(prevState => ({
                                  ...prevState,
                                  is_critical: value,
                                }));
                              }}
                              defaultChecked={
                                formDataValues?.is_critical === "1"
                              }
                            />
                            <div className="slider round"></div>
                          </label>
                        </div>
                      </FormGroup>
                    </Col>

                    <div data-repeater-list="outer-group" className="outer">
                      <Row className="justify-content-end ">
                        <Col lg={12}>
                          <div className="cta text-center gap-3 d-flex justify-content-left mt-4 mb-2">
                            <Button
                              type="button"
                              className="btn btn-secondary"
                              onClick={e => {
                                e.preventDefault();
                                history.push("/questions-list");
                              }}
                            >
                              {" "}
                              {t(`mcq_manager.Cancel`)}
                            </Button>
                            <Button
                              type="submit"
                              className="btn btn-primary"
                              color="success"
                            >
                              {t(`mcq_manager.Submit`)}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Row>
                </div>
              </div>
            </AvForm>
          </Container>
        </div>
      </div>
    </div>
  );
}

export default CreateQuestion;
